<div class="ui-g-12">
  <div class="ui-g">
    <div class="ui-g-12 ui-md-12">

    </div>
    <div class="ui-g-12 ui-md-12">
      <div *ngFor="let indicator of indicators" class="ui-g-3 ui-md-3 ui-sm-6 ui-xs-12">
        <app-infobox [pointData]="indicator.pointData" [t]="indicator.t" [options]="indicator.options"></app-infobox>
      </div>
    </div>
  </div>

  <div class="ui-g ui-fluid dashboard" *ngIf="data != null">
    <p-table [value]="this.srvStoreCampaign.store_list" class="overview-table" [paginator]="true" [rows]="10" [sortMode]="'multiple'">
      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'codice_negozio'">{{ tableHeaders['stores.code'] }}<p-sortIcon [field]="'codice_negozio'"></p-sortIcon></th>
          <th [pSortableColumn]="'descrizione_negozio'">{{ tableHeaders['stores.description'] }}<p-sortIcon [field]="'descrizione_negozio'"></p-sortIcon></th>
          <th [pSortableColumn]="'superficie'">{{ tableHeaders['stores.surface'] }}<p-sortIcon [field]="'superfice'"></p-sortIcon></th>
          <th [pSortableColumn]="'indirizzo'">{{ tableHeaders['stores.address'] }}<p-sortIcon [field]="'indirizzo'"></p-sortIcon></th>
          <th [pSortableColumn]="'comune'">{{ tableHeaders['stores.city'] }}<p-sortIcon [field]="'comune'"></p-sortIcon></th>
          <th [pSortableColumn]="'provincia'">{{ tableHeaders['customerDetail.province'] }}<p-sortIcon [field]="'provincia'"></p-sortIcon></th>
          <th [pSortableColumn]="'revenue'">{{ tableHeaders['stores.revenue'] }}<p-sortIcon [field]="'revenue'"></p-sortIcon></th>
          <th [pSortableColumn]="'insegna'">{{ tableHeaders['stores.label'] }}<p-sortIcon [field]="'insegna'"></p-sortIcon></th>
          <th [pSortableColumn]="'customers'">{{ tableHeaders['stores.customers'] }}<p-sortIcon [field]="'customers'"></p-sortIcon></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-col>
        <tr>
          <td>{{ col.codice_negozio }}</td>
          <td class="">{{ col.descrizione_negozio }}</td>
          <td class="number-column">{{ col.superfice | formatNumber:0  }}</td>
          <td class="">{{ col.indirizzo }}</td>
          <td class="">{{ col.comune }}</td>
          <td class="">{{ col.provincia }}</td>
          <td class="number-column">{{ col.revenue | number : '1.2-2' }}{{ col.revenueUom }}€</td>
          <td class="">{{ col.insegna }}</td>
          <td class="number-column">{{ col.customers | formatNumber:0 }}</td>
        </tr>
      </ng-template>

    </p-table>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/elenco-pdv/elenco-pdv.component.html